import styled from 'styled-components';

export const StyledTitle = styled.h2`
  font-weight: normal;
  padding: 20px;
  font-size: 16px;
  margin: 0;
`;

export const StyledErrorsWrapper = styled.div`
  padding: 0 20px;
`;

export const ActionsContainer = styled.div`
  position: relative;
  height: auto;
  text-align: right;
  padding: 10px;
  box-sizing: border-box;

  &:after{
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #979797;
    opacity: 0.40;
  }
`;
